import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import agreementTypes from "astrid-firestore/src/api/agreements/constants/agreementTypes";

export default function useAgreementTypes() {
	const { t } = useTranslation();

	return useMemo(
		() => ({
			[agreementTypes.FRAMEWORK]: t("agreementTypeFramework", "Framework agreement"),
			[agreementTypes.PRODUCTION]: t("agreementTypeProduction", "Production agreement"),
			[agreementTypes.CLOUD]: t("agreementTypeCloud", "Cloud storage agreement"),
		}),
		[t],
	);
}
